import React, { useState } from "react";
import { Card, Tab, Tabs } from "@mui/material";
import { useRouteMatch, useHistory } from "react-router-dom";
import { Toast } from "@egovernments/digit-ui-react-components";
import Timeline from "../../components/Timeline";
import TabPanel from "../TabPanel";

const Step1 = ({ t, onSelect, formData, currStep, step1Tabs }) => {
  const [showToast, setShowToast] = useState(null);
  const [currentTab, setCurrentTab] = useState(currStep.route);

  const history = useHistory();
  const { path, params } = useRouteMatch();
  const baseUrl = path.substring(0, path.lastIndexOf('/'));
  const getPath = (path, params) => {
    params && Object.keys(params).map(key => {
      path = path.replace(`:${key}`, params[key]);
    })
    return path;
  }
  const updateTabUrl = tab => history.push(`${getPath(baseUrl, params)}/${tab}`);
  const handleTabChange = (e, newValue) => {
    setCurrentTab(newValue);
    updateTabUrl(newValue)
  }

  const closeToast = () => {
    setShowToast(null);
  };

  return (
    <div>
      {showToast && (
        <Toast
          error={true}
          label={t(`${showToast?.message}`)}
          onClose={closeToast}
          isDleteBtn={true}
        />
      )}
      <Timeline flow="Form11" currentStep={currStep.step} />
      <Card className="card" style={{
        boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
        margin: '1.25rem auto 2rem',
        overflow: 'initial',
      }}>
        <Tabs value={currentTab} onChange={handleTabChange}>
          {step1Tabs?.map(({ tabLabel, route }) => (
            <Tab key={route} label={t(tabLabel)} value={route} sx={{
              textTransform: 'none', p: '0 1rem'
            }} />
          ))}
        </Tabs>
        {step1Tabs?.map(({ tabComponent, route }) => {
          let Component = tabComponent;
          if (typeof tabComponent === "string") {
            Component = Digit.ComponentRegistryService.getComponent(tabComponent);
          }
          return (
            <TabPanel value={currentTab} index={route} sx={{ p: 0 }}>
              <Component {...{ t, formData, onSelect, currStep }} />
            </TabPanel>
          )
        })}
      </Card>
    </div>
  )
}

export default Step1;
